import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';
import { createHiddenInput } from 'helpers/form';

@registerElement('patient-checkin')
export default class PatientCheckinElement extends ImpulseElement {
  /**
   * Whether the element is active or not. If active, then attendance can be marked.
   */
  @property({ type: Boolean }) active = false;

  /**
   * An array of patient ids that were selected from the checkboxes.
   */
  @property({ type: Array }) selectedPatientIds: string[] = [];

  /**
   * The form name of the patient ids.
   */
  @property() patientIdsName: string;

  @target() button: HTMLButtonElement;
  @target() checkinForm: HTMLFormElement;
  @target() clearForm: HTMLFormElement;

  constructor() {
    super();
    this.handleDropdownShown = this.handleDropdownShown.bind(this);
    this.handleDropdownHidden = this.handleDropdownHidden.bind(this);
  }

  /**
   * Called when the element is added to the DOM.
   */
  connected() {
    $(this).on('shown.bs.dropdown', this.handleDropdownShown);
    $(this).on('hidden.bs.dropdown', this.handleDropdownHidden);
    if (this.active) {
      this.button.disabled = false;
    }
  }

  /**
   * Called when the element is removed from the DOM.
   */
  disconnected() {
    $(this).off('shown.bs.dropdown', this.handleDropdownShown);
    $(this).off('hidden.bs.dropdown', this.handleDropdownHidden);
  }

  /**
   * Called when the `active` property changes it's state.
   */
  activeChanged(active: boolean) {
    this.button.disabled = !active;
  }

  /**
   * Called when the patient has been checkedin successfully.
   */
  checked() {
    $(this).dropdown('hide');
    this.emit('checked');
  }

  private handleDropdownShown() {
    this.appendPatientIds(this.checkinForm);
    this.appendPatientIds(this.clearForm);
  }

  private handleDropdownHidden() {
    this.removePatientIds();
  }

  private appendPatientIds(form: HTMLFormElement) {
    for (const id of this.selectedPatientIds) {
      const hiddenInput = createHiddenInput(this.patientIdsName, id);
      form.append(hiddenInput);
    }
  }

  private removePatientIds() {
    const hiddenInputs = Array.from(this.querySelectorAll(`[name="${this.patientIdsName}"]`));
    hiddenInputs.forEach((input) => input.remove());
  }
}
